var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStepApproved(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#00703E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 40,
    height: 40,
    rx: 4,
    fill: "#00703E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.4355 23.0635C43.8504 22.6451 44.5243 22.6454 44.9395 23.0635C45.3539 23.4809 45.3539 24.1559 44.9395 24.5732L28.6895 40.9365C28.4825 41.1449 28.2098 41.25 27.9375 41.25C27.6652 41.25 27.3925 41.1449 27.1855 40.9365L19.0605 32.7549C18.6461 32.3375 18.6461 31.6625 19.0605 31.2451C19.4759 30.8269 20.149 30.827 20.5645 31.2451L27.9375 38.6689L43.4355 23.0635Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepApproved);
export default __webpack_public_path__ + "static/media/step-approved.2354beb31680dda2f54bd8d1590e9ffb.svg";
export { ForwardRef as ReactComponent };